var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.slides.length)?_c('SfCarousel',{staticClass:"carousel",attrs:{"settings":{
    autoplay: 5000,
    perView: 1,
    breakpoints: {
      1023: {
        perView: 1,
      },
    },
  }}},_vm._l((_vm.slides),function(slide){return _c('SfCarouselItem',{key:slide.Id,staticClass:"carousel__item"},[_c('Banner',{attrs:{"maxHeight":_vm.maxHeight,"picture":slide.PictureUrl ? _vm.pictureUrlPath(slide.PictureUrl) : null,"background":"#fff","fullWidth":slide.FullWidth,"description":slide.Description,"buttonText":slide.ButtonText,"link":slide.Link}})],1)}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }